export const appConfig = {
  id: "complete-athlete",
  name: "Complete Athlete",
  description: "Complete Athlete application",
  repository: {
    owner: "",
    name: "",
  },
} as const;

export type AppConfig = typeof appConfig;
